module.exports = __webpack_public_path__ + "img/6-1.a392c764.jpg";